import React, { LegacyRef } from "react";
import { Container, Content, Description, Image, ImageContainer, Title } from "./Card.styles";

export interface CardProps {
  reverse?: boolean;
  cardRef: LegacyRef<HTMLDivElement> | undefined;
  title?: string;
  description?: React.ReactNode;
  image?: string;
  alt?: string;
}

const Card: React.FC<CardProps> = ({
  reverse = false,
  cardRef,
  title,
  description,
  image,
  alt = "",
}) => {
  return (
    <Container item xs={12} hasImage={Boolean(image)}>
      <Title variant="h2" component="h2">
        {title}
      </Title>
      <div ref={cardRef} />
      <Content reverse={reverse}>
        {image && (
          <ImageContainer>
            <Image src={image} alt={alt} loading="lazy" />
          </ImageContainer>
        )}
        <Description>{description}</Description>
      </Content>
    </Container>
  );
};

export default Card;
